import { IPaginatedList } from '@samc/common';
import { IReadOptions } from '@samc/common';
import { PageListDataSource } from './BaseDataSources';
import { IMultiTabSetting, IMultiTabSettingsFilter } from '@samc/centricity-core/dist/services/interfaces/responses';

export class MultiTabSettingSource extends PageListDataSource<IMultiTabSetting> {
  public Items: IMultiTabSetting[] = [];

  public constructor(filter: IMultiTabSettingsFilter = { importProcessId: 1 }, pageSize: number = 50) {
    super('/componentapi/dataimport/multiTabSettings', filter, pageSize);
  }

  protected async getRows(options: IReadOptions, abortController: AbortController): Promise<IPaginatedList<IMultiTabSetting>> {
    const result = await super.getRows(options, abortController);
    this.Items = result?.items ?? [];
    return result;
  }
}